//Reference: EN089 (Modified) 

/*  
    Added a new field 'ID_SUB_ROLES' which doesn't belong to the original EN089.
    The reason is to replicate an optimized backend that will return this fields whose value will 
    contain an array of objects from EN076. This relationship EN089 & EN076 belongs to EN077.
*/

import { Mappeable } from './mappeable.model';
import { RoleType } from './role-type.model';
import * as _ from 'lodash';
import moment from 'moment';

export class User extends Mappeable {

    idUserPk: number;
    cdNuuma: string;
    txtName: string;
    txtLastname1: string;
    txtLastname2: string;
    txtFullname: any;
    fullName: string;
    isActive: boolean;
    txtMail: string;
    nmrMobile: number;
    entamap: any;
    typeRole: RoleType;
    mrkActive: boolean;
    organizationalStructure: any;
    language: any;
    dateAdmission: any;
    workLeaveDate: any;
    roles: any;
    professionalCategoryTypes: any;
    secondaryRoles: []
    mobilityFunctional: boolean;
    mobilityGeographic: boolean;
    typeTreatment: string;
    txtComment: string;
    filePhotoName: String;
    fileFirmName: String;
    fileCvEsName: String;
    fileCvEnName: String;
    secondaryOrgStr: [];
    assistedUsers: [];
    evaluableUsers: [];
    
    constructor(o) {
        super(o)
        this.professionalCategoryTypes = _.isUndefined(this.professionalCategoryTypes) || _.isNull(this.professionalCategoryTypes) ? null : [this.professionalCategoryTypes];
        this.mrkActive = this.mrkActive ??  false 
        this.mobilityFunctional = this.mobilityFunctional ??  false 
        this.mobilityGeographic = this.mobilityGeographic ??  false 
       
        this.txtFullname = {
            txtName: this.txtName,
            txtLastname1: this.txtLastname1,
            txtLastname2: this.txtLastname2
        }
        this.fullName = this.setFullname(this.txtFullname);
        this.txtFullname = this.fullName;
        _.forEach(this.assistedUsers, (user: any) => user.txtFullName = this.setFullname(user));
    }

    
    setFullname(user) {
        const lastname1 = user.txtLastname1 ? ' ' + user.txtLastname1 : '';
        const lastname2 = user.txtLastname2 ? ' ' + user.txtLastname2 : '';
        const name = user.txtName ? user.txtName : '';
        return name + lastname1 + lastname2;
    }


    mapToBackAdminUser() {
        return {
            cdNuuma: this.cdNuuma,
            txtName: this.txtName,
            txtLastname1: this.txtLastname1,
            txtLastname2: this.txtLastname2,
            mrkActive: this.mrkActive,
            // Tratamiento
            txtMail: this.txtMail,
            language: this.language,
            entamap: this.entamap,
            nmrMobile: this.nmrMobile,
            dateAdmission: moment(this.dateAdmission).format("YYYY-MM-DD"),
            workLeaveDate: this.workLeaveDate,
            txtComment: this.txtComment,
            // Recibir correos
            filePhotoName: this.filePhotoName,
            fileFirmName: this.fileFirmName,
            fileCvEsName: this.fileCvEsName,
            fileCvEnName: this.fileCvEnName,
            roles: this.roles,
            organizationalStructure: this.organizationalStructure,
            // Estructuras organizativas adicionales
            professionalCategoryTypes: this.professionalCategoryTypes,
            mobilityFunctional: this.mobilityFunctional,
            mobilityGeographic: this.mobilityGeographic,
            typeTreatment: this.typeTreatment,
            secondaryOrgStrIds: !_.isUndefined(this.secondaryOrgStr) ? _.map(this.secondaryOrgStr, 'idOrganizationalStructurePk') : [],
            assistedUsers: this.assistedUsers,
            evaluableUsers: this.evaluableUsers
        }
    }
}